<template>
  <div class="bg-white p-2">
    <DxDataGrid id="gridContainer" v-show="!isShowDetail"
                ref="grid"
                :allow-column-reordering="true"
                :data-source="dataSources"
                :row-alternation-enabled="true"
                :show-borders="true"
                :sync-lookup-filter-values="false"
                @exporting="exportGrid"
    >
      <DxScrolling row-rendering-mode="virtual"/>
      <DxPaging :page-size="15"/>
      <DxGroupPanel :visible="true"/>
      <DxGrouping :auto-expand-all="true"/>
      <DxRemoteOperations :group-paging="true"/>
      <DxFilterRow :visible="true"/>
      <DxFilterPanel :visible="false"/>
<!--      <DxHeaderFilter :visible="true"/>-->
      <DxExport
          :enabled="true"
          :formats="['xlsx']"
      />
      <DxColumn caption="STT" cell-template="indexTemplace"  width="50">
      </DxColumn>
      <template #indexTemplace="{ data }">
        <span>{{data.rowIndex + 1}}</span>
      </template>
      <DxColumn data-field="NGUON" caption="Nguồn" width="80"
                cell-template="sourceTemplace">
        <DxLookup
            :data-source='sourceList'
            value-expr="source"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #sourceTemplace="{ data }">
        <span
            :class="data.data.NGUON==='APP'?'text-info':data.data.NGUON==='WEB'?'text-success':'text-primary'"
        >
          {{ data.data.NGUON }}
        </span>
      </template>
      <DxColumn data-field="PHONE" caption="Số thuê bao" :allow-hiding="false">
      </DxColumn>
<!--      <DxColumn data-field="CUSTOMER_NAME" caption="Tên khách hàng">-->
<!--      </DxColumn>-->
      <DxColumn data-field="CALL_DATE" caption="Thời điểm gọi lên" data-type="date" sortOrder="desc" :allow-hiding="false">
        <DxFormat
            type="shortDateShortTime"
        />
      </DxColumn>
      <DxColumn data-field="APPROVE_DATE" caption="Thời điểm phê duyệt" data-type="date" :hiding-priority="2">
        <DxFormat
            type="shortDateShortTime"
        />
      </DxColumn>
<!--      <DxColumn data-field="STATUS" caption="Trạng thái">-->
<!--        <DxLookup-->
<!--            :data-source='statusList'-->
<!--            value-expr="STATUS"-->
<!--            display-expr="TEXT"-->
<!--        />-->
<!--      </DxColumn>-->
      <DxColumn data-field="APPROVE_STATUS" caption="Trạng thái phê duyệt" cell-template="approveStatusTemplace" :hiding-priority="5">
        <DxLookup
            :data-source='approveStatusList'
            value-expr="STATUS"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #approveStatusTemplace="{ data }">
        <span
            :class="data.data.APPROVE_STATUS===0?'text-warning':data.data.APPROVE_STATUS===1?'text-success':'text-primary'"
        >
          {{approveStatusList.find(item=>{return  data.data.APPROVE_STATUS===item.STATUS}).TEXT  }}
        </span>
      </template>
      <DxColumn data-field="IS_UPDATE" caption="Loại"  cell-template="typeTemplace" :hiding-priority="4">
        <DxLookup
            :data-source='typeList'
            value-expr="isUpdate"
            display-expr="TEXT"
        />
      </DxColumn>
      <template #typeTemplace="{ data }">
        <span
            :class="data.data.IS_UPDATE===0?'text-success':'text-info'"
        >
          {{typeList.find(item=>{return  data.data.IS_UPDATE===item.isUpdate}).TEXT  }}
        </span>
      </template>
<!--      <DxColumn data-field="ACTIVED_DATE" caption="Ngày DKTT">-->
<!--      </DxColumn>-->
      <DxColumn data-field="TDV" caption="Tổng đài viên" :hiding-priority="1">
      </DxColumn>
      <DxColumn data-field="NOTE" caption="Ghi chú" :hiding-priority="3">
      </DxColumn>
<!--      <DxColumn data-field="CountNumber" caption="Số lượt gọi" width="80">-->
<!--      </DxColumn>-->
      <DxColumn caption="Video" name="video" type="buttons" width="50">
        <DxGridButton
            hint="Xem video"
            icon="fa-solid fa-circle-play"
            cssClass="text-primary"
            :on-click="watchVideoFromTable"
        />
      </DxColumn>
      <DxColumn caption="Chi tiết" name="button" type="buttons">
        <DxGridButton
            text="Kiểm tra"
            hint="Xem chi tiết"
            cssClass="text-primary"
            :on-click="openDetailModal"
        />
      </DxColumn>

    </DxDataGrid>
    <b-row v-show="isShowDetail">
      <b-col cols="3">
        <b-row class="min-height-150">
          <b-col cols="12">
            <div class="card-image-container mt-0">
              <div style="position: relative;">
                <img
                  v-if="!groupImage.frontCMND"
                  class="video-image"
                  src="@/assets/images/videoCall/front-card.png"
                />
                <div v-if="groupImage.frontCMND" class="image-container">
                  <v-zoomer>
                    <img
                      :src="groupImage.frontCMND"
                      class="video-image preview-image image-zoom"
                    />
                  </v-zoomer>
                  <div class="image-details"></div>
                </div>
              </div>
              <div class="text-center text-label">Ảnh mặt trước</div>
            </div>
          </b-col>
          <b-col cols="12">
            <div class="card-image-container">
              <div style="position: relative;">
                <img
                  v-if="!groupImage.backCMND"
                  class="video-image"
                  src="@/assets/images/videoCall/back-card.png"
                />
                <div v-if="groupImage.backCMND" class="image-container">
                  <v-zoomer>
                    <img
                      :data-zoom="groupImage.backCMND"
                      :src="groupImage.backCMND"
                      class="video-image preview-image image-zoom1"
                    />
                  </v-zoomer>
                  <div class="image-details1"></div>
                </div>
              </div>
              <div class="text-center text-label">Ảnh mặt sau</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="3">
        <div class="card-image-container mt-0">
          <div class="d-flex justify-content-center">
            <img
              v-if="!groupImage.profilePicture"
              class="video-image"
              src="@/assets/images/videoCall/avatar.png"
            />
            <v-zoomer>
              <img
                v-if="groupImage.profilePicture"
                :src="groupImage.profilePicture"
                class="video-image preview-image"
              />
            </v-zoomer>
          </div>
          <div class="text-center text-label">
            Ảnh chân dung
            <p>Tỉ lệ facematching: {{ cardInfo.faceMatching }}%</p>
          </div>
        </div>
        <div class="card-image-container mt-0">
          <div class="d-flex justify-content-center">
            <img
              v-if="!cardInfo.signData"
              class="video-image"
              src="@/assets/images/videoCall/avatar.png"
            />
            <img
              v-if="cardInfo.signData"
              :src="
                cardInfo.signData.includes('data:image')
                  ? cardInfo.signData
                  : 'data:image/jpg;base64,' + cardInfo.signData
              "
              class="video-image preview-image"
            />
          </div>
          <div class="text-label">Ảnh chữ ký</div>
        </div>
      </b-col>
      <b-col cols="6">
        <b-col cols="12">
          <b-form-group label="Nguồn" label-cols="3">
            <b-form-input
              :value="cardInfo.callSrc"
              disabled
              size="md"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Kênh" label-cols="3">
            <b-form-input
              :value="cardInfo.channel"
              disabled
              size="md"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số thuê bao" label-cols="3">
            <b-form-input
              v-model="cardInfo.telNumber"
              disabled
              size="md"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số liên hệ" label-cols="3">
            <b-form-input
              v-model="cardInfo.contactPhone"
              disabled
              size="md"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số serial" label-cols="3">
            <b-form-input
              v-model="cardInfo.serial"
              disabled
              size="md"
              type="text"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Đối tượng sử dụng" label-cols="3">
            <b-form-input disabled size="md" type="text" value="Bản thân" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Loại giấy tờ" label-cols="3">
            <!--                <b-form-input v-model="cardInfo.cardType" size="md" type="text"/>-->
            <select v-model="cardInfo.cardType" class="form-control">
              <option value="1">CMT</option>
              <option value="45">CCCD</option>
              <option value="47">Căn Cước</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số giấy tờ" label-cols="3">
            <b-form-input
              v-model="cardInfo.idCard"
              size="md"
              ref="idCardInput"
              type="text"
              @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Số hộ chiếu" label-cols="3">
            <b-form-input size="md" type="text" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Họ và tên" label-cols="3">
            <b-form-input
              v-model="cardInfo.name"
              size="md"
              ref="nameInput"
              type="text"
              @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ngày sinh" label-cols="3">
            <b-form-input
              v-model="cardInfo.dob"
              size="md"
              ref="dobInput"
              type="text"
              @change="handleChangeInfo"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Giới tính" label-cols="3">
            <!--                <b-form-input v-model="cardInfo.gender" size="md" type="text"/>-->
            <select v-model="cardInfo.gender" class="form-control">
              <option value="male">Nam</option>
              <option value="female">Nữ</option>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Địa chỉ" label-cols="3">
            <b-form-input v-model="cardInfo.address" size="md" type="text" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Ngày cấp" label-cols="3">
            <b-form-input v-model="cardInfo.issueDate" size="md" type="text" />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Nơi cấp" label-cols="3">
            <!--                <b-form-input-->
            <!--                  disabled-->
            <!--                  v-model="cardInfo.issueAt"-->
            <!--                  size="md"-->
            <!--                  type="text"-->
            <!--                />-->
            <select v-model="cardInfo.issueAt" class="form-control">
              <option
                v-for="place in issuedPlaceList"
                :value="place.ISSUED_PLACE_CODE"
                >{{ place.ISSUED_PLACE_NAME }}
              </option>
            </select>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group label="Quốc tịch" label-cols="3">
            <!--                <b-form-input v-model="cardInfo.nationality" size="md" type="text"/>-->
            <b-form-input size="md" type="text" value="Việt nam" />
          </b-form-group>
        </b-col>
        <b-col cols="12" class="font-medium-3 font-weight-bold"
          >Kết quả check C06
        </b-col>
        <b-col cols="12" class="text-primary mb-1" v-if="isErrorC06">
          <div class="d-flex align-items-baseline">
            <i
              class="fa-solid fa-triangle-exclamation mr-2"
              style="color: #ff0000;font-size: 1.5rem"
            ></i>
            <b>THUÊ BAO CHECK C06 CHƯA THÀNH CÔNG</b>
          </div>
        </b-col>
        <b-col cols="12">
          <table class="table border text-center">
            <thead>
              <tr>
                <th>STT</th>
                <th>Tên Trường</th>
                <th>Kết quả</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(field, index) in c06Field">
                <td class="border">{{ index + 1 }}</td>
                <td class="border">{{ field.name }}</td>
                <td class="border ">
                  {{ field.status ? "Đúng" : "Sai" }}
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Ghi chú"
            label-cols="3"
            v-if="cardInfo.approveStatus === 0"
          >
            <select2 v-model="note" :options="noteList"></select2>
            <b-form-input
              class="mt-1"
              v-model="noteDiff"
              size="md"
              type="text"
            />
          </b-form-group>
          <b-form-group label="Ghi chú" label-cols="3" v-else>
            <b-form-input class="mt-1" v-model="note" size="md" type="text" />
          </b-form-group>
        </b-col>
      </b-col>
    </b-row>
    <b-row v-show="isShowDetail" style="margin-top: 28px;">
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <button
            v-if="cardInfo.videoLink && cardInfo.videoLink.length > 0"
            class="btn btn-primary "
            @click="watchVideo()"
          >
            Xem Video
          </button>
          <button
            v-if="cardInfo.approveStatus === 0 "
            class="btn btn-primary ml-2"
            @click="checkC06()"
          >
            Check C06
          </button>
          <!--              <button-->
          <!--                v-if="cardInfo.status != 1"-->
          <!--                class="btn btn-primary ml-2"-->
          <!--                @click="clearSign()"-->
          <!--              >-->
          <!--                Ký lại-->
          <!--              </button>-->
          <button
            v-if="cardInfo.approveStatus === 0  && cardInfo.isUpdate"
            class="btn btn-primary ml-2"
            @click="onUpdateContract()"
          >
            Xem phiếu
          </button>
          <button
            v-if="cardInfo.approveStatus === 0 && !cardInfo.isUpdate"
            class="btn btn-primary ml-2"
            @click="onRegisterContract()"
          >
            Xem phiếu
          </button>
          <button
            v-if="cardInfo.approveStatus === 0 && !cardInfo.isUpdate"
            :disabled="contractBase64.length === 0"
            class="btn btn-success ml-2 "
            @click="onRegister()"
          >
            Đăng ký
          </button>
          <button
            v-if="cardInfo.approveStatus === 0 && cardInfo.isUpdate"
            :disabled="contractBase64.length === 0"
            class="btn btn-success ml-2 "
            @click="onUpdate()"
          >
            Cập nhật
          </button>
          <button
            v-if="cardInfo.approveStatus === 0 && !isTDVAd"
            class="btn btn-success ml-2 "
            @click="onRefuse(1)"
            :disabled="!isWatchedVideo"
          >
            Duyệt Đăng ký/ Cập nhật
          </button>
          <button
            v-if="cardInfo.approveStatus === 0  && !isTDVAd"
            class="btn btn-secondary ml-2"
            @click="onRefuse(2)"
            :disabled="!isWatchedVideo"
          >
            Từ chối
          </button>
          <button class="btn btn-primary ml-2" @click="hideDetail()">
            Đóng
          </button>
        </div>
      </b-col>
    </b-row>
    <b-modal id="check-status-modal" hide-footer title="Check kích hoạt">
      <p>Số thuê bao <span class="text-primary">*</span></p>
      <div class="d-flex">
        <b-form-input
          class="w-75 form-control"
          placeholder="087xxx"
        ></b-form-input>
        <button class="w-25 ml-1 btn btn-primary">Kiểm tra</button>
      </div>
    </b-modal>
    <b-modal id="view-video-modal" hide-footer size="lg" title="Video">
      <!--      <video :src="video" controls playsinline></video>-->
      <div>
        <video
          ref="videoPlayer"
          class="video-js"
          style="max-width: 100%; max-height: 80vh"
        ></video>
      </div>
      <button class="btn btn-primary mt-2" @click="downloadVideo">
        Tải Video
      </button>
    </b-modal>
    <!--    <b-modal-->
    <!--      id="change-status-modal"-->
    <!--      hide-footer-->
    <!--      title="Chuyển trạng thái kích hoạt"-->
    <!--    >-->
    <!--      <p>Trạng thái mới</p>-->
    <!--      <Select2 :options="statusList" />-->
    <!--      <p class="mt-1">Ghi chú</p>-->
    <!--      <b-form-input class=" form-control"></b-form-input>-->
    <!--      <div class="d-flex justify-content-end mt-2">-->
    <!--        <button class="btn btn-primary">Lưu</button>-->
    <!--        <button class="btn btn-secondary ml-2">Hủy</button>-->
    <!--      </div>-->
    <!--    </b-modal>-->
    <b-modal
      id="modal-contract"
      :title="
        cardInfo.isUpdate
          ? 'Phiếu cập nhật thông tin thuê bao'
          : 'Phiếu đăng ký thông tin thuê bao'
      "
      hide-footer
      size="lg"
    >
      <template>
        <b-row>
          <b-col class="ml-auto" cols="12">
            <img
                :src="prefixImgLink + contractBase64"
                class="video-image"
                alt="video-image"/>
            <!--            <embed :src="'data:application/pdf;base64,'+contractBase64" style="height: 80vh; width: 55vw">-->
          </b-col>
        </b-row>
        <hr />
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BPagination,
  BRow,
  BSpinner
} from "bootstrap-vue";
import Select2 from "v-select2-component";
import { VueGoodTable } from "vue-good-table";
import "@core/scss/vue/libs/vue-good-table.scss";
import useJwt from "@/auth/jwt/useJwt";
import { ValidationProvider } from "vee-validate";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "axios";
import { $ctx } from "@themeConfig";
import VueSignatureCanvas from "vue-signature-canvas";
import { checkIsTDVAd } from "@/store/TDVList";
import videojs from "video.js";
import {
  DxColumn,
  DxDataGrid,
  DxFilterPanel,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLookup,
  DxPaging,
  DxRemoteOperations,
  DxScrolling,
  DxFormat,
  DxButton as DxGridButton,
  DxExport
} from "devextreme-vue/data-grid";
import 'devextreme/data/odata/store';
import viMessages from "devextreme/localization/messages/vi.json";
import { exportDataGrid as exportDataGridToPdf} from 'devextreme/pdf_exporter';
import { exportDataGrid } from 'devextreme/excel_exporter';
import {loadMessages, locale} from "devextreme/localization";
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';
import { jsPDF } from 'jspdf';
import {prefixImgLink} from "@/store/helper";

export default {
  name: "VideoCallDSTB",
  components: {
    DxGrouping,
    DxFilterPanel, DxRemoteOperations, DxHeaderFilter, DxGroupPanel, DxDataGrid, DxScrolling, DxPaging,
    DxFilterRow, DxLookup,DxFormat,
    DxColumn,DxGridButton,DxExport,
    BSpinner,
    BFormGroup,
    BRow,
    BCol,
    ValidationProvider,
    BButton,
    Select2,
    BFormDatepicker,
    BFormInput,
    VueGoodTable,
    VueSignatureCanvas,
    BPagination
  },
  created() {
    loadMessages(viMessages);
    locale("vi-VN");
  },
  watch:{
    isShowDetail(val){
      if(!val){
        this.$refs.grid.instance.refresh();
      }
    }
  },
  data() {
    return {
      dataSources: {
        store: {
          type: "odata",
          version: 4,
          url: $ctx.API_URL + "odata.svc/VIDEO_CALL_LIST_BUSYs",
          beforeSend: e => {
            e.headers = {
              apiKey: localStorage.getItem("accessToken")
            };
          }
        }
      },
      statusList: [
        {STATUS: 0, TEXT: "Chưa xử lý"},
        {STATUS: 1, TEXT: "Hoàn thành"},
        {STATUS: 2, TEXT: "Từ chối"}
      ],
      approveStatusList: [
        {STATUS: 0, TEXT: "Chưa duyệt"},
        {STATUS: 1, TEXT: "Đã duyệt"},
        {STATUS: 2, TEXT: "Từ chối"},
      ],
      typeList: [
        {isUpdate: 0, TEXT: "Đăng ký"},
        {isUpdate: 1, TEXT: "Cập nhật"},
      ],
      sourceList: [
        {source: "POS", TEXT: "POS"},
        {source: "WEB", TEXT: "WEB"},
        {source: "APP", TEXT: "APP"},
      ],
      isShowDetail: false,
      player: null,
      isTDVAd: false,
      issuedPlaceList: [],
      isErrorC06: false,
      c06Field: [
        {
          id: "idnumber_result",
          name: "Số giấy tờ",
          status: false
        },
        {
          id: "name_result",
          name: "Họ và tên",
          status: false
        },
        {
          id: "dob_result",
          name: "Ngày sinh",
          status: false
        }
      ],
      options: {
        penColor: "rgb(56, 63, 255)",
        backgroundColor: "rgb(255, 255, 255)"
      },
      totalRecords: 0,
      groupImage: {
        frontCMND: "",
        backCMND: "",
        profilePicture: ""
      },
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        pageSize: 50
      },
      video: "",
      fromDate: "",
      toDate: "",
      tableData: [],
      fields: [
        {
          field: "SOURCE",
          label: "Nguồn",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 0, text: "WEB" },
              { value: 1, text: "POS" },
              { value: 2, text: "APP" }
            ]
          }
        },
        {
          field: "PHONE",
          label: "Số STB",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" },
          tdClass: "text-center"
        },
        {
          field: "CUSTOMER_NAME",
          label: "Tên khách hàng",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" },
          tdClass: "text-center"
        },
        {
          field: "CALL_DATE",
          label: "Thời điểm gọi lên ",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "APPROVE_DATE",
          label: "Thời điểm phê duyệt",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "STATUS",
          label: "Trạng thái",
          tdClass: "text-center",
          filterOptions: {
            enabled: true,
            filterDropdownItems: [
              { value: 0, text: "Chưa duyệt đăng ký/ cập nhật" },
              { value: 1, text: "Đã duyệt đăng ký/ cập nhật" },
              { value: 2, text: "Từ chối phê duyệt" }
            ]
          }
        },
        {
          field: "ACTIVED_DATE",
          label: "Ngày DKTT",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "USER_APPROVE",
          label: "Người duyệt",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "TDV",
          label: "Tổng đài viên",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "NOTE",
          label: "Ghi chú",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "countNumber",
          label: "Số lượt gọi",
          tdClass: "text-center",
          filterOptions: { enabled: true, placeholder: "", trigger: "enter" }
        },
        {
          field: "video",
          label: "Video",
          tdClass: "text-center"
        },
        {
          field: "action",
          label: "Action"
        }
      ],
      user: "",
      note: "",
      noteDiff: "",
      userList: [],
      statusListDKTT: [
        { id: 0, text: "Chưa duyệt đăng ký" },
        { id: 1, text: "Đã duyệt đăng ký" },
        { id: 2, text: "Từ chối duyệt đăng ký" }
      ],
      statusListCNTT: [
        { id: 0, text: "Chưa duyệt cập nhật" },
        { id: 1, text: "Đã duyệt cập nhật" },
        { id: 2, text: "Từ chối duyệt cập nhật" }
      ],
      cardInfo: {
        ID: "",
        name: "",
        idCard: "",
        dueDate: "",
        dob: "",
        address: "",
        hometown: "",
        gender: "",
        issueDate: "",
        issueAt: "",
        telNumber: "",
        nationality: "",
        serial: "",
        signData: "",
        cardType: "",
        cityCode: "",
        contactPhone: "",
        faceMatching: "",
        videoLink: "",
        status: "",
        callSrc: "",
        channel: "",
        isUpdate: "",
        call_id: "",
        approveStatus:0
      },
      contractBase64: "",
      signDataAdmin: "",
      URL_WEB_API: $ctx.API_URL.includes("dev")
        ? "https://itel.dev"
        : "https://itel.vn",
      POS_API_URL: $ctx.API_URL.includes("dev")
        ? "https://pos.itel.dev/api/pos/"
        : "https://pos.itel.vn/api/pos/",
      noteList: [
        {
          id: "01_Mặt trước giấy tờ mờ",
          text: "01_Mặt trước giấy tờ mờ"
        },
        {
          id: "02_Mặt sau giây tờ mờ",
          text: "02_Mặt sau giây tờ mờ"
        },
        {
          id: "03_Chân dung không hợp lệ",
          text: "03_Chân dung không hợp lệ"
        },
        {
          id: "04_Sai tên",
          text: "04_Sai tên"
        },
        {
          id: "05_Sai số giấy tờ",
          text: "05_Sai số giấy tờ"
        },
        {
          id: "06_Sai ngày sinh",
          text: "06_Sai ngày sinh"
        },
        {
          id: "07_Sai địa chỉ",
          text: "07_Sai địa chỉ"
        },
        {
          id: "08_Sai ngày cấp",
          text: "08_Sai ngày cấp"
        },
        {
          id: "09_Sai nơi cấp",
          text: "09_Sai nơi cấp"
        },
        {
          id: "10_Giấy tờ hết hạn",
          text: "10_Giấy tờ hết hạn"
        },
        {
          id: "11_Thiếu chữ ký khách hàng",
          text: "11_Thiếu chữ ký khách hàng"
        },
        {
          id: "1",
          text: "Khác"
        }
      ],
      isWatchedVideo: false,
      currentId: "",
      prefixImgLink,
    };
  },
  mounted() {
    this.getCallList();
    this.getIssuedPlace();
    const userData = JSON.parse(localStorage.getItem("userData"));
    this.signDataAdmin = JSON.parse(localStorage.getItem("userData")).signature;
    this.isTDVAd = checkIsTDVAd(userData.username);
  },
  methods: {
    exportGrid(e) {
      if (e.format === 'xlsx') {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          worksheet: worksheet,
          component: e.component,
        }).then(function() {
          workbook.xlsx.writeBuffer().then(function(buffer) {
            saveAs(new Blob([buffer], { type: "application/octet-stream" }), "DanhSachCuocGoi.xlsx");
          });
        });
      }
      else if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: e.component,
        }).then(() => {
          doc.save('DanhSachCuocGoi.pdf');
        });
      }
    },
    hideDetail() {
      this.isShowDetail = false;
      this.getCallList();
    },
    getIssuedPlace() {
      useJwt
        .get("getIssuedPlace")
        .then(res => {
          this.issuedPlaceList = res.data.result;
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lấy danh sách nơi cấp thất bại!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        });
    },
    checkC06() {
      this.loading(true);
      this.isErrorC06 = false;
      this.c06Field.forEach(item => {
        item.status = false;
      });
      useJwt
        .post("check-info", {
          idNumber: this.cardInfo.idCard,
          phone: this.cardInfo.telNumber,
          birthDay: this.cardInfo.dob,
          fullName: this.cardInfo.name
        })
        .then(res => {
          this.loading(false);
          if (!res.data.result) {
            if (res.data.code === 201) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "C06 Lỗi",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              this.isErrorC06 = true;
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Thông tin giấy tờ trùng khớp!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
            }
            this.c06Field.forEach(item => {
              item.status = true;
            });
            this.$refs.idCardInput.state = true;
            this.$refs.nameInput.state = true;
            this.$refs.dobInput.state = true;
            // this.$refs.idCardInput.disabled = true;
            // this.$refs.nameInput.disabled = true;
            // this.$refs.dobInput.disabled = true;
          }
        })
        .catch(err => {
          this.loading(false);
          if (err.response) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title:
                  "Thông tin giấy tờ chưa khớp với cơ sở dữ liệu dân cư quốc gia, Vui lòng kiểm tra lại thông tin giấy tờ",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            if (err.response.data.result) {
              if (err.response.data.result.idnumber_result == "true") {
                this.c06Field[0].status = true;
                this.$refs.idCardInput.state = true;
              } else {
                this.$refs.idCardInput.state = false;
              }
              if (err.response.data.result.name_result == "true") {
                this.c06Field[1].status = true;
                this.$refs.nameInput.state = true;
              } else {
                this.$refs.nameInput.state = false;
              }
              if (err.response.data.result.dob_result == "true") {
                this.$refs.dobInput.state = true;
                this.c06Field[2].status = true;
              } else {
                this.$refs.dobInput.state = false;
              }
            }
          }
        });
    },
    onColumnFilter(params) {
      console.log(params);
      this.serverParams = {
        columnFilters: params.columnFilters,
        page: 1,
        pageSize: 50
      };
      this.getCallList();
    },
    async onPerPageChange() {
      this.serverParams.pageSize = parseInt(this.serverParams.pageSize);
      this.serverParams.page = 1;
      this.getCallList();
    },
    async onPageChange(params) {
      console.log(params);
      this.serverParams.page = params;
      this.getCallList();
    },
    watchVideo() {
      this.isWatchedVideo = true;
      if (this.video === "") {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Cuộc gọi không có video",
            icon: "AlertTriangleIcon",
            variant: "danger"
          }
        });
        return;
      }
      this.$bvModal.show("view-video-modal");
      setTimeout(() => {
        this.player = videojs(
          this.$refs.videoPlayer,
          {
            autoplay: true,
            controls: true,
            sources: [
              {
                src: this.video,
                type: "video/mp4"
              }
            ]
          },
          () => {}
        );
      }, 500);
      // this.showLoading(true);
      // useJwt
      //   .post("download-video/" + id, {})
      //   .then(res => {
      //     this.isWatchedVideo = true;
      //     this.video = "data:video/mp4;base64," + res.data.result;
      //     this.$bvModal.show("view-video-modal");
      //     this.showLoading(false);
      //   })
      //   .catch(err => {
      //     this.showLoading(false);
      //     this.$toast({
      //       component: ToastificationContent,
      //       props: {
      //         title: "Cuộc gọi không có video",
      //         icon: "AlertTriangleIcon",
      //         variant: "danger"
      //       }
      //     });
      //   });
    },
    watchVideoFromTable(data) {
      const row=data.row.data
      this.showLoading(true);
      useJwt
        .post("get-list-his-call-detail/" + row.ID, {
          page: 1,
          pageSize: 1000
        })
        .then(res => {
          this.showLoading(false);
          let data = res.data.result[res.data.result.length - 1];
          this.currentId = data.ID;
          if (data.VIDEO_LINK) {
            this.mapVideoLink(data.VIDEO_LINK);
            this.watchVideo();
          } else {
            this.showLoading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cuộc gọi không có video",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          }
        })
        .catch(err => {
          this.showLoading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Có lỗi xảy ra vui lòng thử lại",
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    async getCallList() {
      this.showLoading(true);
      useJwt
        .post("get-list-his-call-busy", this.serverParams)
        .then(res => {
          this.showLoading(false);
          this.totalRecords = res.data.totalRecords;
          this.tableData = res.data.result.map(e => {
            e.CALL_DATE = moment(e.CALL_DATE).format("YYYY-MM-DD HH:mm:ss");
            e.REGISTER_DATE = e.REGISTER_DATE
              ? moment(e.REGISTER_DATE).format("YYYY-MM-DD HH:mm:ss")
              : "";
            e.APPROVE_DATE = e.APPROVE_DATE
              ? moment(e.APPROVE_DATE).format("YYYY-MM-DD HH:mm:ss")
              : "";
            if (e.STATUS === 1 && !e.APPROVE_DATE) {
              e.STATUS = 0;
            }
            if (e.POS_AGEN_ID && e.POS_AGEN_ID.length > 0) {
              if (e.POS_AGEN_ID == 0) {
                e.SOURCE = "APP";
              } else {
                e.SOURCE = "POS";
              }
            } else {
              e.SOURCE = "WEB";
            }
            if (e.SOURCE === "WEB") {
              e.SOURCE_TEXT_COLOR = "text-warning";
            }
            if (e.SOURCE === "APP") {
              e.SOURCE_TEXT_COLOR = "text-info";
            }
            if (e.SOURCE === "POS") {
              e.SOURCE_TEXT_COLOR = "text-primary";
            }
            e.soLuotGois = "";
            e.video = "";
            e.action = "";
            return e;
          });
        })
        .catch(err => {
          this.showLoading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Có lỗi xảy ra vui lòng thử lại",
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    mapVideoLink(link) {
      if (link) {
        if (link.includes("video1")) {
          this.video = "https://hn.ss.bfcplatform.vn/videocall/" + link;
        } else {
          this.video = "https://hn.ss.bfcplatform.vn/itel-shop-test/" + link;
        }
      } else {
        this.video = "";
      }
    },
    async openDetailModal(data) {
      const row=data.row.data
      this.showLoading(true);
      this.video = "";
      useJwt
        .post("get-list-his-call-detail/" + row.ID, {
          page: 1,
          pageSize: 1000
        })
        .then(res => {
          let data = res.data.result[res.data.result.length - 1];
          if (data.BIRTH_DAY.length === 4) {
            data.BIRTH_DAY = "01/01/" + data.BIRTH_DAY;
          }
          this.currentId = data.ID;
          this.cardInfo.ID = data.ID;
          this.cardInfo.call_id = data.CALL_ID;
          this.cardInfo.name = data.FULL_NAME;
          this.cardInfo.idCard = data.ID_NUMBER;
          this.cardInfo.dueDate = moment(data.ISSUE_DATE, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
          this.cardInfo.dob = moment(data.BIRTH_DAY, "DD/MM/YYYY").format(
            "DD/MM/YYYY"
          );
          this.cardInfo.address = data.ADDRESS;
          this.cardInfo.hometown = data.HOME_TOWN;
          this.cardInfo.gender = data.GENDER;
          if (data.ISSUE_DATE && data.ISSUE_DATE.length > 0) {
            this.cardInfo.issueDate = moment(
              data.ISSUE_DATE,
              "DD/MM/YYYY"
            ).format("DD/MM/YYYY");
          } else {
            this.cardInfo.issueDate = "";
          }
          this.cardInfo.telNumber = data.PHONE;
          this.cardInfo.nationality = data.INTERNATIONAL;
          this.cardInfo.serial = data.SERI;
          this.cardInfo.signData = data.IMAGE4
            ? "data:image/jpeg;base64," + data.IMAGE4
            : "";
          this.cardInfo.cityCode = data.CITY_CODE;
          this.cardInfo.contactPhone = data.CONTACT_PHONE;
          this.cardInfo.faceMatching = data.FACE_MATCHING;
          this.cardInfo.videoLink = data.VIDEO_LINK;
          this.cardInfo.status = row.STATUS;
          this.cardInfo.approveStatus = row.APPROVE_STATUS;
          this.cardInfo.posAgenId = data.POS_AGEN_ID;
          this.cardInfo.channel = data.CHANEL;
          //check loai giay to
          if (data.CARD_TYPE == "CCCD") {
            this.cardInfo.cardType = "45";
          } else if (data.CARD_TYPE == "CMT") {
            this.cardInfo.cardType = "1";
          } else {
            this.cardInfo.cardType = data.CARD_TYPE;
          }
          //check noi cap
          if (data.ISSUE_PLACE) {
            if (data.ISSUE_PLACE.length == 3) {
              this.cardInfo.issueAt = data.ISSUE_PLACE;
            } else {
              this.onCheckIssueAt(
                data.ISSUE_PLACE,
                this.cardInfo.cardType == "1"
              );
            }
          } else {
            this.cardInfo.issueAt = "";
          }

          if (this.cardInfo.posAgenId && this.cardInfo.posAgenId.length > 0) {
            if (this.cardInfo.posAgenId == 0) {
              this.cardInfo.callSrc = "APP";
            } else {
              this.cardInfo.callSrc = "POS";
            }
          } else {
            this.cardInfo.callSrc = "WEB";
          }
          this.cardInfo.isUpdate = row.IS_UPDATE;
          this.note = data.NOTE1 ? data.NOTE1 : "";
          this.noteDiff = "";
          this.isWatchedVideo = false;
          this.c06Field.forEach(item => {
            item.status = false;
          });
          this.mapVideoLink(data.VIDEO_LINK);
          this.groupImage.frontCMND = data.IMAGE1
            ? "data:image/jpeg;base64," + data.IMAGE1
            : "";
          this.groupImage.backCMND = data.IMAGE2
            ? "data:image/jpeg;base64," + data.IMAGE2
            : "";
          this.groupImage.profilePicture = data.IMAGE3
            ? "data:image/jpeg;base64," + data.IMAGE3
            : "";
          this.contractBase64 = "";
          this.checkC06();
          this.isShowDetail = true;
          // this.$bvModal.show("call-detail-modal");
          setTimeout(() => {
            // new Drift(document.querySelector(".image-zoom"), {
            //   paneContainer: document.querySelector(".image-details"),
            //   zoomFactor: 4
            // });
            // new Drift(document.querySelector(".image-zoom1"), {
            //   paneContainer: document.querySelector(".image-details1"),
            //   zoomFactor: 4
            // });
            // document.getElementById("signAdmin").children[0].width = 300;
            // document.getElementById("signAdmin").children[0].height = 300;
            // document.getElementById("signAdmin").children[0].background =
            //   "white";
          }, 1000);
          this.showLoading(false);
        })
        .catch(err => {
          this.showLoading(false);
          console.log("err openDetailModal-->", err);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Có lỗi xảy ra vui lòng thử lại",
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    async onCheckIssueAt(issueAt, isCMT) {
      this.loading(true);
      const params = {
        type: isCMT ? "CMT" : "CCCD",
        placeName: issueAt
      };
      await useJwt
          .post(
              "issuedPlace",
              params
          )
        .then(
          response => {
            this.loading(false);
            // console.log("response --->", response);
            this.cardInfo.issueAt = response.data.data.onSelect.issuedPlaceCode;
          },
          error => {
            this.loading(false);
            console.log("error", error);
          }
        );
    },
    async saveNote() {
      await useJwt
        .get(
          "update-note/" +
            this.cardInfo.call_id +
            "/" +
            this.cardInfo.telNumber,
          {
            params: {
              msg:
                this.note === "1"
                  ? this.noteDiff
                  : this.note + " " + this.noteDiff
            }
          }
        )
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lưu ghi chú thành công",
              icon: "AlertTriangleIcon",
              variant: "success"
            }
          });
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Lưu ghi chú thất bại",
              icon: "AlertTriangleIcon",
              variant: "danger"
            }
          });
        });
    },
    async onRefuse(type) {
      //type 1 phe duyet, 2 tu choi

      if (type === 2) {
        if (this.note.length <= 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Vui lòng nhập ghi chú!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
          return;
        }
        if (this.noteDiff.length <= 0 && this.note === "1") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Vui lòng nhập ghi chú!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
          return;
        }
      }
      if (type === 1) {
        if (!this.c06Field[1].status && !this.c06Field[2].status) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Vui lòng kiểm tra thông tin C06!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
          return;
        }
      }

      this.loading(true);
      await useJwt
        .post("refuse1/" + this.cardInfo.telNumber + "/" + type, {
          note:
            this.note === "1" ? this.noteDiff : this.note + " " + this.noteDiff
        })
        .then(res => {
          this.loading(false);
          this.cardInfo.approveStatus = type;
          if (type === 2) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Đã từ chối thuê bao!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          }
          if (type === 1) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Đã phê duyệt thuê bao!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          }
        })
        .catch(err => {
          this.loading(false);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response?.data?.message
                ? err.response?.data?.message
                : "Từ chối thuê bao thất bại! Vui lòng thử lại!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        });
    },
    showLoading(type) {
      if (type) {
        document.getElementById("loading-bg").style.display = "block";
      } else {
        document.getElementById("loading-bg").style.display = "none";
      }
    },
    onRegister() {
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
          ? this.groupImage.frontCMND
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        img2: this.groupImage.backCMND
          ? this.groupImage.backCMND
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        img3: this.groupImage.profilePicture
          ? this.groupImage.profilePicture
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        hd: this.contractBase64,
        call_id: this.cardInfo.call_id
      };
      this.saveNote();
      if (this.cardInfo.callSrc === "WEB") {
        useJwt
          .post("pos_sub_registration", data, {
            timeout: 120000
          })
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã đăng ký thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Đăng ký thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Đăng ký thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
      if (this.cardInfo.callSrc === "POS") {
        axios
          .post(
            this.POS_API_URL + "pos_sub_registration_VD",
            {
              agentCode: this.cardInfo.posAgenId,
              ...data
            },
            {
              timeout: 120000
            }
          )
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã đăng ký thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Đăng ký thông tin lỗi!";
              console.log(errText + " " + res?.data?.message);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Đăng ký thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
      if (this.cardInfo.callSrc === "APP") {
        axios
          .post(
            this.POS_API_URL + "pos_sub_registration_VD",
            {
              agentCode: this.cardInfo.posAgenId,
              ...data
            },
            {
              timeout: 120000
            }
          )
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã đăng ký thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Đăng ký thông tin lỗi!";
              console.log(errText + " " + res?.data?.message);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Đăng ký thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
    },
    onUpdate() {
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob.replace(/-/g, "/"),
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate.replace(/-/g, "/"),
        psContactPhone: this.cardInfo.contactPhone,
        img1: this.groupImage.frontCMND
          ? this.groupImage.frontCMND
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        img2: this.groupImage.backCMND
          ? this.groupImage.backCMND
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        img3: this.groupImage.profilePicture
          ? this.groupImage.profilePicture
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", "")
          : null,
        hd: this.contractBase64,
        call_id: this.cardInfo.call_id
      };
      this.saveNote();
      if (this.cardInfo.callSrc === "WEB") {
        useJwt
          .post("pos_sub_update_info", data, {
            timeout: 120000
          })
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã cập nhật thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Cập nhật thông tin lỗi!";
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Cập nhật thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
      if (this.cardInfo.callSrc === "POS") {
        axios
          .post(
            this.POS_API_URL + "pos_sub_update_info_VD",
            {
              agentCode: this.cardInfo.posAgenId,
              ...data
            },
            {
              timeout: 120000
            }
          )
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã cập nhật thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Cập nhật thông tin lỗi!";
              console.log(errText + " " + res?.data?.message);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Cập nhật thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
      if (this.cardInfo.callSrc === "APP") {
        useJwt
          .post(
            "pos_sub_update_info",
            {
              agentCode: this.cardInfo.posAgenId,
              ...data
            },
            {
              timeout: 120000
            }
          )
          .then(res => {
            this.loading(false);
            if (res?.data?.code == 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Khách hàng đã cập nhật thành công!",
                  icon: "AlertTriangleIcon",
                  variant: "success"
                }
              });
              // this.approveTel()
              this.updateStatusRegis();
            } else {
              this.isDisableRegister = false;
              const errText = res?.data?.message
                ? res?.data?.message
                : "Cập nhật thông tin lỗi!";
              console.log(errText + " " + res?.data?.message);
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: errText,
                  icon: "AlertTriangleIcon",
                  variant: "warning"
                }
              });
            }
          })
          .catch(err => {
            this.loading(false);
            this.isDisableRegister = false;
            const errText = err?.response?.data?.message
              ? err?.response?.data?.message
              : "Đăng ký thông tin lỗi!";
            this.$toast({
              component: ToastificationContent,
              props: {
                title: errText,
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          });
      }
    },
    updateStatusRegis() {
      useJwt
        .post("update-status-regis", {
          name: this.cardInfo.name,
          msisdn: this.cardInfo.telNumber,
          source: "OUTCALL",
          call_id: this.cardInfo.call_id
        })
        .then(res => {
          if (res.data.code === 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cập nhật trạng thái thành công!",
                icon: "AlertTriangleIcon",
                variant: "success"
              }
            });
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: res.data.message
                  ? res.data.message
                  : "Cập nhật trạng thái lỗi!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
          }
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.data.message
                ? err.response.data.message
                : "Cập nhật trạng thái lỗi!",
              icon: "AlertTriangleIcon",
              variant: "warning"
            }
          });
        });
    },
    clearSign() {
      this.$refs.handWriteAdmin.clearSignature();
      this.signDataAdmin = "";
    },
    handleChangeInfo() {
      this.c06Field[0].status = false;
      this.c06Field[1].status = false;
      this.c06Field[2].status = false;
      this.$refs.idCardInput.state = null;
      this.$refs.dobInput.state = null;
      this.$refs.nameInput.state = null;
      this.contractBase64 = "";
    },
    async onUpdateContract() {
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.c06Field[1].status && !this.c06Field[2].status) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      const data = {
        subscribers: [
          {
            phone: this.cardInfo.telNumber.replace("84", "0"),
            seri: this.cardInfo.serial
          }
        ],
        psHoten: this.cardInfo.name,
        psCmnd: this.cardInfo.idCard,
        psNgaysinh: this.cardInfo.dob,
        psQuoctich: "232",
        psnoicap: this.cardInfo.issueAt,
        psdiachi: this.cardInfo.address,
        psGioiTinh: this.cardInfo.gender,
        ploaigt: this.cardInfo.cardType,
        psplacedate: this.cardInfo.issueDate,
        img1: this.groupImage.frontCMND,
        img2: this.groupImage.backCMND,
        img3: this.groupImage.profilePicture,
        signatureImage: this.cardInfo.signData,
        psContactPhone: this.cardInfo.contactPhone,
        psHomeTown: this.cardInfo.hometown,
        psCityCode: this.cardInfo.cityCode,
        faceMatching: this.cardInfo.faceMatching,
        agency_signatureImage: this.signDataAdmin
          .replace("data:image/jpeg;base64,", "")
          .replace("data:image/png;base64,", "")
          .replace("data:image/jpg;base64,", ""),
        tdv: JSON.parse(localStorage.getItem("userData")).fullName,
        call_id: this.cardInfo.call_id
      };
      if (this.cardInfo.callSrc === "WEB") {
        useJwt
          .postEx(
            this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf",
            data
          )
          .then(res => {
            this.contractBase64 = res.data.result.img4_link;
            this.$bvModal.show("modal-contract");
            this.loading(false);
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loading(false);
          });
      }
      if (this.cardInfo.callSrc === "POS") {
        useJwt
          .postEx(this.POS_API_URL + "pos_sub_update_info_form_vd", {
            agentCode: this.cardInfo.posAgenId,
            ...data
          })
          .then(res => {
            this.contractBase64 = res.data.result.img4_link;
            this.$bvModal.show("modal-contract");
            this.loading(false);
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loading(false);
          });
      }
      if (this.cardInfo.callSrc === "APP") {
        useJwt
          .postEx(
            this.URL_WEB_API + "/api/web/pos_sub_update_info_form_pdf_APP",
            data
          )
          .then(res => {
            this.contractBase64 = res.data.result.img4_link;
            this.$bvModal.show("modal-contract");
            this.loading(false);
          })
          .catch(err => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loading(false);
          });
      }
    },
    async onRegisterContract() {
      if (!this.cardInfo.telNumber) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra số thuê bao!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      if (!this.c06Field[1].status && !this.c06Field[2].status) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Vui lòng kiểm tra thông tin C06!",
            icon: "AlertTriangleIcon",
            variant: "warning"
          }
        });
        return;
      }
      this.loading(true);
      useJwt
        .get("get-phone-in-idNumber/" + this.cardInfo.idCard)
        .then(res => {
          if (res.data?.result?.result?.length >= 3) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Thuê bao đã được đăng ký 3 số thuê bao!",
                icon: "AlertTriangleIcon",
                variant: "warning"
              }
            });
            this.loading(false);
            return;
          }
          const data = {
            subscribers: [
              {
                phone: this.cardInfo.telNumber.replace("84", "0"),
                seri: this.cardInfo.serial
              }
            ],
            psHoten: this.cardInfo.name,
            psCmnd: this.cardInfo.idCard,
            psNgaysinh: this.cardInfo.dob,
            psQuoctich: "232",
            psnoicap: this.cardInfo.issueAt,
            psdiachi: this.cardInfo.address,
            psGioiTinh: this.cardInfo.gender,
            ploaigt: this.cardInfo.cardType,
            psplacedate: this.cardInfo.issueDate,
            img1: this.groupImage.frontCMND,
            img2: this.groupImage.backCMND,
            img3: this.groupImage.profilePicture,
            signatureImage: this.cardInfo.signData,
            psContactPhone: this.cardInfo.contactPhone,
            psHomeTown: this.cardInfo.hometown,
            psCityCode: this.cardInfo.cityCode,
            faceMatching: this.cardInfo.faceMatching,
            agency_signatureImage: this.signDataAdmin
              .replace("data:image/jpeg;base64,", "")
              .replace("data:image/png;base64,", "")
              .replace("data:image/jpg;base64,", ""),
            tdv: JSON.parse(localStorage.getItem("userData")).fullName,
            call_id: this.cardInfo.call_id
          };
          if (this.cardInfo.callSrc === "WEB") {
            useJwt
              .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_pdf",
                data
              )
              .then(res => {
                this.contractBase64 = res.data.result.img4_link;
                this.$bvModal.show("modal-contract");
                this.loading(false);
              })
              .catch(err => {
                console.log("err-->", err);
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
                this.loading(false);
              });
          }
          if (this.cardInfo.callSrc === "POS") {
            useJwt
              .postEx(this.POS_API_URL + "pos_sub_registration_form_VD", {
                agentCode: this.cardInfo.posAgenId,
                ...data
              })
              .then(res => {
                this.contractBase64 = res.data.result.img4_link;
                this.$bvModal.show("modal-contract");
                this.loading(false);
              })
              .catch(err => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
                this.loading(false);
              });
          }
          if (this.cardInfo.callSrc === "APP") {
            useJwt
              .postEx(
                this.URL_WEB_API + "/api/web/pos_sub_registration_form_APP",
                data
              )
              .then(res => {
                this.contractBase64 = res.data.result.img4_link;
                this.$bvModal.show("modal-contract");
                this.loading(false);
              })
              .catch(err => {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Vui lòng kiểm tra dữ liệu và thử lại!",
                    icon: "AlertTriangleIcon",
                    variant: "warning"
                  }
                });
                this.loading(false);
              });
          }
        })
        .catch(err => {
          this.loading(false);
        });
    },
    downloadVideo() {
      if (this.video) {
        this.showLoading(true);
        useJwt
          .post("download-video/" + this.currentId, {})
          .then(res => {
            const link = document.createElement("a");
            link.href = "data:video/mp4;base64," + res.data.result;
            link.download = "download.mp4";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.showLoading(false);
          })
          .catch(err => {
            this.showLoading(false);
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Cuộc gọi không có video",
                icon: "AlertTriangleIcon",
                variant: "danger"
              }
            });
          });
      }
    }
  }
};
</script>

<style lang="scss">
@import url("../../../node_modules/video.js/dist/video-js.css");

#call-detail-modal {
  .modal-dialog {
    max-width: 95vw !important;
  }
}
</style>
<style lang="scss" scoped>
.card-image-container {
  margin-top: 65px;
  position: relative;

  .text-label {
    text-align: center;
    margin-top: 11px;

    color: #4b4b4b;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 21px;
  }

  .camera-icon {
    position: absolute;
    right: 21px;
    bottom: 14px;
    cursor: pointer;
  }
}

.video-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
